import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { TECHNO_CATEGORIES } from '@/utils/constants'
import { isEmpty, concat, get } from 'lodash'
import helpers from './helpers'
import { errorHandler } from '@/utils/helpers'

const actions = {
    retrieveItems({ commit, rootState }) {
        //check if techno data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'technology', null)
        if (!dataType) return

        const countryCode3 = get(rootState, 'account.country.code3', 0)
        if (countryCode3 === 0) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(countryCode3, rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(isp => {
                if (get(isp, 'status') === 'KO') {
                    errorHandler('Error while retrieving internet service provider (ISP) data', commit)
                } else if (!isEmpty(isp.list)) {
                    const countryCode2 = get(rootState, 'account.country.code2', '')
                    commit('setRetrievedItems', {
                        items: concat(TECHNO_CATEGORIES.isp, helpers.parseData(isp.list, countryCode2))
                    })
                    commit('setCollection', helpers.instanciateAll(isp.list, countryCode2))
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
